<div  class="container-fluid container-background">
    
    
  <!-- header row top bar contains title, menu, options -->
  <div class="row">
  
      <!-- affixed header box sets padding for right menu -->
      <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">
      
      <div class="outer">
      <div class="middle">
          
      <div class="login-form-container">
          
          
      <div class="login-header-title">
          <i class="zmdi zmdi-lock zdmi-fw"></i> Password reset
      </div>
          
      <sync-error-display-hash [errors]="errors">
      </sync-error-display-hash>
          
          
          
      <div [hidden]="!success" class="alert alert-info">
          <i class="ion-checkmark-circled fa-lg syncblue"></i>
          Your new password has been saved, <a routerLink="/login">Log in</a>
      </div>
  
      
      
  <form (submit)="submit()" ngNativeValidate>
  
              <div class="form-group" [hidden]="!req2FA">
                  <label>Two factor Authentication Code:</label>
                  <div class="input-group">
                      <input
                          autocomplete="off"
                          type="text"
                          [(ngModel)]="twofacode"
                          class="input-lg form-control login-form-control"
                          id="twofacode"
                          name="twofacode"
                      />
                  </div>
              </div>
  
              <div class="form-group" [hidden]="req2FA">
  
                  <label>Reset code:</label>
                  <input
                      type="text"
                      required
                      [(ngModel)]="resetCode"
                      class="input-lg form-control login-form-control"
                      id="text-auth-password-reset-code"
                      name="text"
                  />
              </div>
  
              <div class="form-group"  [hidden]="req2FA">
                  <label>New password:</label>
                      <input
                          required
                          type="password"
                          [(ngModel)]="newPass1"
                          class="input-lg form-control login-form-control"
                          id="text-auth-password-reset-pass1"
                          name="password"
                          syncShowHidePassword
                          identity="resetpass"
                      />
              </div>
              <sync-complex-password [password]="newPass1"></sync-complex-password>
              <div class="form-group" [hidden]="req2FA">
                  <label>Confirm new password:</label>
                      <input
                          required
                          type="password"
                          [(ngModel)]="newPass2"
                          class="input-lg form-control login-form-control"
                          id="text-auth-password-reset-pass2"
                          name="password"
                          syncShowHidePassword
                          identity="resetpass"
                      />
              </div>
  
              <div class="form-group"><br />
                  <button
                      [disabled]="spinner"
                      id="btn-auth-login"
                      type="submit"
                      class="btn-block btn btn-primary btn-lg btn-login-other showhand"
                  ><i *ngIf="spinner" class="fa fa-spin fa-spinner"></i>
                      Reset password
                  </button>
              </div>
          </form>
  
      
          
          </div> <!-- login form conteiner -->
          
          </div> <!-- middle -->
          </div> <!-- outer -->
      
      
      </div>
      <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
          <!-- future -->
          
      </div>
          
        
  
  </div> <!-- row -->
      
  </div>
  